/**
 * Mock data para Mercados (Países de operación)
 * Centralizado en módulo SGI
 */

import { Market, MarketStatus } from '../entities/market';

/**
 * Mock markets - Países donde OWLY Platform opera
 */
export const MOCK_MARKETS: Market[] = [
  {
    id: 'market-co',
    countryId: 'co',
    isoCode: 'CO',
    name: 'Colombia',
    flag: '🇨🇴',
    status: MarketStatus.ACTIVE,
    isActive: true,
    isConfigured: true,
    addedAt: new Date('2025-01-01'),
    lastConfiguredAt: new Date('2025-01-15'),
    configProgress: {
      basicInfo: true,
      minimumWage: true,
      currencies: true,
      subsidyPlans: true,
      cities: true,
    },
    primaryCurrency: 'COP',
    currencies: [
      { currencyId: 'COP', isPrimary: true, isAccepted: true },
      { currencyId: 'USD', isPrimary: false, isAccepted: true },
      { currencyId: 'EUR', isPrimary: false, isAccepted: true },
    ],
    minimumWage: {
      value: 1300000,
      currency: 'COP',
      lastUpdated: new Date('2025-01-01'),
    },
    subsidyPlans: [
      {
        id: 'sp-co-1',
        code: 'VIS',
        name: 'Vivienda de Interés Social',
        isActive: true,
        createdAt: new Date('2025-01-01'),
        updatedAt: new Date('2025-01-15'),
      },
      {
        id: 'sp-co-2',
        code: 'VIP',
        name: 'Vivienda de Interés Prioritario',
        isActive: true,
        createdAt: new Date('2025-01-01'),
        updatedAt: new Date('2025-01-15'),
      },
      {
        id: 'sp-co-3',
        code: 'NOVIS',
        name: 'No VIS',
        isActive: true,
        createdAt: new Date('2025-01-01'),
        updatedAt: new Date('2025-01-15'),
      },
    ],
    cities: [],
    regulations: {
      requiresSubsidyPlan: 'required' as const,
      requiresMinimumWage: 'required' as const,
      allowsForeignCurrency: true,
    },
    createdAt: new Date('2025-01-01'),
    updatedAt: new Date('2025-01-15'),
  },
  {
    id: 'market-cr',
    countryId: 'cr',
    isoCode: 'CR',
    name: 'Costa Rica',
    flag: '🇨🇷',
    status: MarketStatus.INCOMPLETE,
    isActive: true,
    isConfigured: false,
    addedAt: new Date('2025-01-10'),
    configProgress: {
      basicInfo: true,
      minimumWage: false,
      currencies: true,
      subsidyPlans: false,
      cities: false,
    },
    primaryCurrency: 'CRC',
    currencies: [
      { currencyId: 'CRC', isPrimary: true, isAccepted: true },
      { currencyId: 'USD', isPrimary: false, isAccepted: true },
    ],
    subsidyPlans: [],
    cities: [],
    regulations: {
      requiresSubsidyPlan: 'optional' as const,
      requiresMinimumWage: 'optional' as const,
      allowsForeignCurrency: true,
    },
    createdAt: new Date('2025-01-10'),
    updatedAt: new Date('2025-01-10'),
  },
  {
    id: 'market-do',
    countryId: 'do',
    isoCode: 'DO',
    name: 'República Dominicana',
    flag: '🇩🇴',
    status: MarketStatus.INCOMPLETE,
    isActive: true,
    isConfigured: false,
    addedAt: new Date('2025-01-12'),
    configProgress: {
      basicInfo: true,
      minimumWage: false,
      currencies: false,
      subsidyPlans: false,
      cities: false,
    },
    primaryCurrency: 'DOP',
    currencies: [
      { currencyId: 'DOP', isPrimary: true, isAccepted: true },
    ],
    subsidyPlans: [],
    cities: [],
    regulations: {
      requiresSubsidyPlan: 'optional' as const,
      requiresMinimumWage: 'optional' as const,
      allowsForeignCurrency: false,
    },
    createdAt: new Date('2025-01-12'),
    updatedAt: new Date('2025-01-12'),
  },
  {
    id: 'market-mx',
    countryId: 'mx',
    isoCode: 'MX',
    name: 'México',
    flag: '🇲🇽',
    status: MarketStatus.ACTIVE,
    isActive: true,
    isConfigured: true,
    addedAt: new Date('2024-11-01'),
    lastConfiguredAt: new Date('2025-01-05'),
    configProgress: {
      basicInfo: true,
      minimumWage: true,
      currencies: true,
      subsidyPlans: true,
      cities: true,
    },
    primaryCurrency: 'MXN',
    currencies: [
      { currencyId: 'MXN', isPrimary: true, isAccepted: true },
      { currencyId: 'USD', isPrimary: false, isAccepted: true },
    ],
    minimumWage: {
      value: 248.93,
      currency: 'MXN',
      lastUpdated: new Date('2024-12-01'),
    },
    subsidyPlans: [
      {
        id: 'sp-mx-1',
        code: 'INFONAVIT',
        name: 'INFONAVIT',
        isActive: true,
        createdAt: new Date('2024-11-01'),
        updatedAt: new Date('2025-01-05'),
      },
      {
        id: 'sp-mx-2',
        code: 'FOVISSSTE',
        name: 'FOVISSSTE',
        isActive: true,
        createdAt: new Date('2024-11-01'),
        updatedAt: new Date('2025-01-05'),
      },
      {
        id: 'sp-mx-3',
        code: 'BANCARIO',
        name: 'Crédito Bancario',
        isActive: true,
        createdAt: new Date('2024-11-01'),
        updatedAt: new Date('2025-01-05'),
      },
    ],
    cities: [],
    regulations: {
      requiresSubsidyPlan: 'optional' as const,
      requiresMinimumWage: 'required' as const,
      allowsForeignCurrency: true,
    },
    createdAt: new Date('2024-11-01'),
    updatedAt: new Date('2025-01-05'),
  },
  {
    id: 'market-pe',
    countryId: 'pe',
    isoCode: 'PE',
    name: 'Perú',
    flag: '🇵🇪',
    status: MarketStatus.INCOMPLETE,
    isActive: true,
    isConfigured: false,
    addedAt: new Date('2025-01-15'),
    configProgress: {
      basicInfo: true,
      minimumWage: true,
      currencies: true,
      subsidyPlans: false,
      cities: false,
    },
    primaryCurrency: 'PEN',
    currencies: [
      { currencyId: 'PEN', isPrimary: true, isAccepted: true },
      { currencyId: 'USD', isPrimary: false, isAccepted: true },
    ],
    minimumWage: {
      value: 1025,
      currency: 'PEN',
      lastUpdated: new Date('2025-01-01'),
    },
    subsidyPlans: [],
    cities: [],
    regulations: {
      requiresSubsidyPlan: 'optional' as const,
      requiresMinimumWage: 'required' as const,
      allowsForeignCurrency: true,
    },
    createdAt: new Date('2025-01-15'),
    updatedAt: new Date('2025-01-15'),
  },
];

/**
 * Helper para obtener un mercado por ID
 */
export function getMarketById(id: string): Market | undefined {
  return MOCK_MARKETS.find((market) => market.id === id);
}

/**
 * Helper para obtener un mercado por código de país
 */
export function getMarketByCountryCode(countryCode: string): Market | undefined {
  return MOCK_MARKETS.find((market) => market.isoCode === countryCode);
}

/**
 * Helper para obtener mercados por status
 */
export function getMarketsByStatus(status: MarketStatus): Market[] {
  return MOCK_MARKETS.filter((market) => market.status === status);
}

/**
 * Helper para obtener mercados activos
 */
export function getActiveMarkets(): Market[] {
  return MOCK_MARKETS.filter((market) => market.isActive);
}

/**
 * Helper para obtener mercados configurados
 */
export function getConfiguredMarkets(): Market[] {
  return MOCK_MARKETS.filter((market) => market.isConfigured);
}
